import React, {useContext} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import {useSettings} from "../../contexts/SettingsContext";
import ContactForm from "./ContactForm";
import contactMailLight from "../../assets/images/contactMail.webp";
import contactMailDark  from "../../assets/images/contactMailDark.svg";

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  const {isVisible} = useSettings();
  const formEnabled = isVisible("sections.contactForm");

  return (
    <Fade bottom duration={1000} distance="20px">
      <section
        className={`rd-contact ${isDark ? "rd-contact--dark" : "rd-contact--light"}`}
        id="contact"
      >
        <div className="rd-contact__inner">
          {/* LEFT — image (swaps with the active theme) */}
          <div className="rd-contact__media">
            <img
              key={isDark ? "dark" : "light"}
              src={isDark ? contactMailDark : contactMailLight}
              alt="Get in touch"
              loading="lazy"
            />
          </div>

          {/* RIGHT — copy + form */}
          <div className="rd-contact__panel">
            <h2 className="rd-contact__title">{contactInfo.title}</h2>
            <p className="rd-contact__subtitle">{contactInfo.subtitle}</p>

            {formEnabled ? (
              <ContactForm />
            ) : (
              <div className="rd-contact__static">
                {contactInfo.number && (
                  <a className="rd-contact__line" href={"tel:" + contactInfo.number}>
                    {contactInfo.number}
                  </a>
                )}
                <a
                  className="rd-contact__line"
                  href={"mailto:" + contactInfo.email_address}
                >
                  {contactInfo.email_address}
                </a>
              </div>
            )}

            <div className="rd-contact__social">
              <SocialMedia />
            </div>
          </div>
        </div>
      </section>
    </Fade>
  );
}
